export default class AINoteFiltersViewModel {
    public isActive: boolean = false;
    public noteState: string | null = null;
}